<template>
  <div class="app-container">
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.search.provinceId"
              filterable
              clearable
              placeholder="请选择省区"
              style="width:100%"
              @change="changeProvinceFun"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.search.cityId"
              filterable
              clearable
              placeholder="请选择城市"
              style="width:100%"
              @change="changeCityFun"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.search.userId"
              filterable
              clearable
              placeholder="请选择人员"
              style="width:100%"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.search.collectionDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择采集日期"
              style="width: 100%;"
            />
          </el-col>
          <el-col style="width:70px;padding-left:10px;">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
          <el-col
            :span="3"
            style="padding-top:3px"
          >
            <el-tag type="danger">
              蓝色店铺点，红色采集点
            </el-tag>
          </el-col>
        </el-row>
      </div>
      <!-- 地图信息 -->
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div
          ref="container"
          :style="{width:EchartsWidth,height: EchartsHeight }"
          class="map-container"
        />
      </div>
    </div>
  </div>
</template>

<script>
// 数据请求
import markerBlue from '@/assets/png/markerBlue.png'
import markerRed from '@/assets/png/markerRed.png'
import { loadAreaDataApi } from '@/api/area'
import { loadUserSelectDataByRegionIdsApi } from '@/api/user'
import { findRetailSurveyInfoByMapApi } from '@/api/retailSurveyInfo'
export default {
  name: 'StoreLocationMap',
  components: {
  },
  mixins: [],
   data () {
    return {
      // 主列表
      masterList: {
        // 查询条件
        search: {
          provinceId: null,
          cityId: null,
          userId: null,
          collectionDate: ''
        }
      },
      markerBlue: markerBlue,
      markerRed: markerRed,
      provinceOptions: [],
      cityOptions: [],
      userOptions: [],
      dialogViewTitle: '当前采集定位',
      dialogViewVisible: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      EchartsHeight: (document.body.clientHeight - 135 )+'px',
      EchartsWidth:(document.body.clientWidth - 240)+'px',
      reportMap: null, // 地图底层
      reportMarker: null, //标记数组
      reportInfo: null //提示框
    }
  },
   created () {
    this.userOptions = []
    this.$nextTick(() => {
      this.initProvinceSelectData()
    })
  },
  methods: {
    // 加载数据
    searchData () {
      if(this.masterList.search.provinceId === null || this.masterList.search.provinceId === undefined || this.masterList.search.provinceId === ''){
        this.$message({
          message: '请选择省区',
          type: 'warning'
        })
        return false
      }
      if(this.masterList.search.cityId === null || this.masterList.search.cityId === undefined || this.masterList.search.cityId === ''){
        this.$message({
          message: '请选择城市',
          type: 'warning'
        })
        return false
      }
      if(this.masterList.search.userId === null || this.masterList.search.userId === undefined || this.masterList.search.userId === ''){
        this.$message({
          message: '请选择用户',
          type: 'warning'
        })
        return false
      }
      if(this.masterList.search.collectionDate === null || this.masterList.search.collectionDate === undefined || this.masterList.search.collectionDate === ''){
        this.$message({
          message: '请选择日期',
          type: 'warning'
        })
        return false
      }
      this.loading = true
      findRetailSurveyInfoByMapApi({userId: this.masterList.search.userId, collectionDate: this.masterList.search.collectionDate}).then(res => {
        let resultData = res.data
        if(resultData === null || resultData.length === 0){
          this.dataMapFun(resultData,30.653442,104.065681)
        } else {
          let firstObj = {}
          for(let obj of resultData){
            if(obj.lat !== null && obj.lat !== undefined){
              firstObj = obj;
              break;
            }
          }
          if(firstObj.lat === null || firstObj.lat === undefined){
            this.dataMapFun(resultData,30.653442,104.065681)
          } else {
            this.dataMapFun(resultData,firstObj.lat,firstObj.lng)
          }
        }
        this.loading = false
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData(){
      loadAreaDataApi({ parentId: 1, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun(val){
      this.cityOptions = []
      this.userOptions = []
      this.masterList.search.cityId = null
      this.masterList.search.countyId = null
      this.initCitySelectData(val)
    },
    // 初始城市下拉数据
    initCitySelectData(val){
      loadAreaDataApi({ parentId: val, isUserArea : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val){
      this.userOptions = []
      this.masterList.search.countyId = null
      this.initUserSelectData(val)
    },
    // 初始用户下拉数据
    initUserSelectData(val){
      loadUserSelectDataByRegionIdsApi({ regionIds: val, isOutsideUser : 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.userOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 地图
    dataMapFun(dataList,lat,lng){
      let _this = this
      let center = new TMap.LatLng(lat, lng);
      if(_this.reportMap === null){
        _this.reportMap = new TMap.Map(_this.$refs.container, {
          zoom: 13,
          center: center,
          draggable: true,
          scrollable: true,
        })
      } else {
        _this.reportMap.setCenter(center)
      }
      if(_this.reportInfo === null){
        _this.reportInfo = new TMap.InfoWindow({
            map: _this.reportMap,
            position: new TMap.LatLng(lat, lng),
            offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
        });
        _this.reportInfo.close();//初始关闭信息窗关闭
      }
      let geometriesData = []
      if(dataList.length > 0){
        for(let i = 0; i < dataList.length; i++){
          if(dataList[i].lat !== null && dataList[i].lat !== undefined){
            geometriesData.push({id: dataList[i].id,styleId: 'markerRed',position: new TMap.LatLng(dataList[i].lat, dataList[i].lng), properties:{title: dataList[i].storeName, realName: dataList[i].realStoreName}})
          }
          if(dataList[i].storeLat !== null && dataList[i].storeLat !== undefined){
            geometriesData.push({id: dataList[i].id,styleId: 'marker',position: new TMap.LatLng(dataList[i].storeLat, dataList[i].storeLng), properties:{title: dataList[i].storeName, realName: dataList[i].realStoreName}})
          }
        }
      }
      if(_this.reportMarker === null){
        if(dataList.length === 0){
          return
        }
        _this.reportMarker = new TMap.MultiMarker({
            id: 'MultiMarker', //图层id
            map: _this.reportMap,
            styles: {
                "marker": new TMap.MarkerStyle({
                    "width": 40,
                    "height": 40,
                    "anchor": { x: 20, y: 32 },
                    "src": _this.markerBlue
                }),
                "markerRed": new TMap.MarkerStyle({
                    "width": 40,
                    "height": 40,
                    "anchor": { x: 20, y: 32 },
                    "src": _this.markerRed
                })
            },
            geometries: geometriesData
        })
        //监听标注点击事件
        _this.reportMarker.on("click", function (evt) {
            //设置infoWindow
            _this.reportInfo.open(); //打开信息窗
            _this.reportInfo.setPosition(evt.geometry.position);//设置信息窗位置
            if(evt.geometry.properties.realName !== null && evt.geometry.properties.realName !== undefined && evt.geometry.properties.realName !== ''){
              _this.reportInfo.setContent(evt.geometry.properties.title+"("+evt.geometry.properties.realName+")");//设置信息窗内容
            } else {
              _this.reportInfo.setContent(evt.geometry.properties.title);//设置信息窗内容
            }
        })
      } else {
        _this.reportMarker.setGeometries(geometriesData)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.map-container {
  padding-top: 5px;
}
</style>
